import CryptoJS from 'crypto-js'
import * as api from '../services/api'
const AuthTokenIv = 'c598Gq0YQK2QUlMA'; // 向量
// 加密
export const encrypt = async (data) => {
    const res = await api.getSecurityKey({});
    const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Latin1.parse(res), {
        iv: CryptoJS.enc.Latin1.parse(AuthTokenIv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
};

// 解密
export const decrypt = (data) => {
    const decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Latin1.parse(AuthTokenKey), {
        iv: CryptoJS.enc.Latin1.parse(AuthTokenIv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};